import { mobileMenu } from "@doddle-agency/doddle-base";

mobileMenu("hamburger", "menu", "site-header");

window.addEventListener("load", async () => {
  const mediaChoiceExists =  document.getElementById('media-choice');
  if (typeof(mediaChoiceExists) != 'undefined' && mediaChoiceExists != null)
  {
    import("./main/mediaChoiceCarousel.js");
  }

  const mobileCarouselExists =  document.getElementById('mobile-carousel');
  if (typeof(mobileCarouselExists) != 'undefined' && mobileCarouselExists != null)
  {
    import("./main/mobile-carousel.js");
  }

  const carouselOverlayExists =  document.getElementById('carousel--cnt');
  if (typeof(carouselOverlayExists) != 'undefined' && carouselOverlayExists != null)
  {
    import("./main/heroCarouselOverlay.js");
  }

  const carouselPlainExists =  document.getElementById('hero-carousel');
  if (typeof(carouselPlainExists) != 'undefined' && carouselPlainExists != null)
  {
    import("./main/heroCarouselPlain.js");
  }

  const { testimonialCarousel } = await import("./main/testimonialSlider.js");
  if (document.getElementsByClassName("testimonial--slider").length) {
    testimonialCarousel();
  }

  const { applyHeightBkgImgHeroOverlay } = await import(
    "./main/heightHeroOverlay.js"
  );
  if (document.getElementsByClassName("hero-bkg-img-overlay").length) {
    applyHeightBkgImgHeroOverlay();
  }

  const { subMenuBtn } = await import("./main/addSubMenuBtn.js");
  subMenuBtn();

  const { menu } = await import("./main/menu.js");
  menu();
});

window.addEventListener("resize", async () => {
  const { applyHeightBkgImgHeroOverlay } = await import(
    "./main/heightHeroOverlay.js"
  );
  if (document.getElementsByClassName("hero-bkg-img-overlay").length) {
    applyHeightBkgImgHeroOverlay();
  }
});